/* Editorial Botanical Wellness interactions: focused overlays, quiet motion, no framework dependency. */
document.documentElement.classList.remove('no-js');

const bindModal = (openSelector, modalSelector, closeSelector) => {
  const open = document.querySelector(openSelector);
  const modal = document.querySelector(modalSelector);
  const close = document.querySelector(closeSelector);
  if (!open || !modal || !close) return;
  const show = () => {
    modal.hidden = false;
    document.body.classList.add('modal-open');
    const firstField = modal.querySelector('input, a, button');
    window.setTimeout(() => firstField?.focus(), 50);
  };
  const hide = () => {
    modal.hidden = true;
    document.body.classList.remove('modal-open');
    open.focus();
  };
  open.addEventListener('click', show);
  close.addEventListener('click', hide);
  modal.addEventListener('click', (event) => { if (event.target === modal) hide(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) hide(); });
};

bindModal('[data-search-open]', '[data-search-modal]', '[data-search-close]');
bindModal('[data-menu-open]', '[data-menu-modal]', '[data-menu-close]');
